<template>
    <div class="position-box"> 
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('order.title')}}</div>
            <img class="icon2" src="@/assets/icon_hall_keep.png" @click="showDate" alt="">    
        </div> 
        <div class="cont-box">
           <vue-better-scroll class="wrapper"
                         ref="scroll"                         
                         :scrollbar="scrollbarObj"
                         :pullDownRefresh="pullDownRefreshObj"
                         :pullUpLoad="pullUpLoadObj"
                         :startY="parseInt(startY)" 
                         :probeType="1"
                         :listenScroll=true
                         @scroll="scroll"                                             
                         @pulling-down="onPullingDown"
                         @pulling-up="onPullingUp">
                <ul class="ul-box">                    
                    <li class="list" v-for="(item,index) in listData" :key="index" @click="jump(item.id)">
                        <div class="list-head">
                            <div class="info-box">
                                <div class="title">{{$t('order.ddh')}}{{item.order_sn}}</div>
                                <div class="price-box">
                                    <div class="text1">{{$t('order.kjmc')}}{{item.mm_name}}</div>
                                </div>
                                <div class="sl-box">
                                    <div class="text1">{{$t('order.jg')}}{{item.money}} USDT</div>
                                    <div class="text2">{{$t('order.gmsl')}}{{item.num}}</div>
                                </div>
                                <div class="sl-box">
                                    <div class="text1">{{item.create_time | times(timestamp)}}</div>                                    
                                </div>
                            </div>
                            <img class="arrow" src="@/assets/more2.png" alt="">
                        </div>
                    </li>                 
                </ul>
                <no-data v-show="hasData"></no-data>  
            </vue-better-scroll> 
            <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        </div> 
        <div class="mask" v-show="isMask"></div>     
        <div class="alert-wrap2" v-show="isDate">
            <div class="alert-head">
                {{this.$t('wdkj.sx')}}
                <img class="icon" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="input-box">
                <input class="input" v-model="startTime" readonly type="text" @click="setDate" :placeholder="this.$t('wdkj.kssj')"><div class="line"></div><input class="input" v-model="endTime" readonly type="text" :placeholder="this.$t('wdkj.jssj')"  @click="setDate2">
            </div>
            <div class="btn-box">
                <button class="btn reset" type="button" @click="cancle">{{this.$t('wdkj.reset')}}</button>
                <button class="btn sure" type="button" @click="sure">{{this.$t('wdkj.sure')}}</button>
            </div>
        </div> 
        <mt-datetime-picker
            ref="picker"                
            type="date"
            v-model="startTime"
            :startDate="startDate"  
            :cancelText="cancelText"  
            :confirmText="confirmText"
            @confirm="dateConfirm"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>
        <mt-datetime-picker
            ref="picker2"               
            type="date"
            v-model="endTime"
            :startDate="startDate"  
            :cancelText="cancelText"  
            :confirmText="confirmText"            
            @confirm="dateConfirm2"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>            
    </div>    
</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that = this;
export default {
    name: 'wdkj',
    data () {
        return {
            listData: [],
            hasData: false,  
            isTop: false, 
            isShow: false, 
            isDate: false,
            isMask: false, 
            isReset: false,
            startTime: '',
            startTimes: '',
            endTimes: '',
            startDate: '',
            selectedValue: '',
            endDate:'',
            endTime:'',
            cancelText: '',
            confirmText: '',               
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')              
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')                    
                }
            },
            startY: 0, // 纵轴方向初始化位置            
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10,
            timestamp: 0, 
        }            
    }, 
    beforeCreate(){
        that = this;
    },
    created(){  
        this.startDate = new Date('2015/1/1');        
        this.endDate = new Date(); 
        this.cancelText = this.$t('duihuang.qx');   
        this.confirmText = this.$t('wdkj.sure');     
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token'); 
        this.timestamp = localStorage.getItem('timestamp') || 0; 
    },
    mounted() {           
        this.init();
    },     
    methods: {
        init(startTimes,endTimes){  
            let params = {                
                uid: this.uid,
                token: this.token,
                start_time: startTimes,
                end_time: endTimes,
                limit: this.limit,
                page: this.page
            }          
            this.$ajax.post('/api/Mmorder/indexList',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                     if(resData.length > 0){        
                        this.hasData = false
                        this.listData = resData;
                        this.$refs.scroll.forceUpdate(true)      
                    }else{
                        this.hasData = true;                       
                    }                       
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },
         /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = []; 
            this.page = 1;
            this.init(this.curIdx,this.type)
        },
        onPullingUp(){            
            this.page ++;
            let params = {
                uid: this.uid,
                token: this.token,
                start_time: this.startTimes,
                end_time: this.endTimes,
                limit: this.limit,
                page: this.page
            } 
            this.$ajax.post('/api/Mmorder/indexList',params).then((res) => {                
                let resData = res.data.data;         
                if(res.data.code == 200){                                          
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);                        
                        this.$refs.scroll.forceUpdate(true) 
                    }else{
                         this.$refs.scroll.forceUpdate(false) 
                    }                
                }else{
                    this.$router.push('/login')               
                }
            }).catch(function(err){
                console.log(err); 
            })   
        }, 
        scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },    
        // 滚动到页面顶部
        scrollTo() {            
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
         setDate(){   
            this.isReset = false; 
            if(this.selectedValue) {
                this.startTime = this.selectedValue;
            }else {
                this.startTime = this.formatDate(new Date());
            }
            this.$refs.picker.open();
        },
        setDate2(){   
            this.isReset = false;            
            if(this.selectedValue) {
                this.endTime = this.selectedValue
            }else {
                this.endTime = this.formatDate(new Date());
            }
            this.$refs.picker2.open();
        },
        dateConfirm(){ // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.startTime = this.formatDate(this.$refs.picker.value);  
            this.selectedValue = this.formatDate(this.$refs.picker.value);                              
        },
        dateConfirm2(){ // 时间选择器确定按钮，并把时间转换成我们需要的时间格式            
            this.endTime = this.formatDate(this.$refs.picker2.value);  
            this.selectedValue = this.formatDate(this.$refs.picker2.value);
        },
        formatDate(data) { 
            const y = data.getFullYear();
            let m = data.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = data.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d
        },
        showDate(){ 
            this.isReset = true;
            this.startTime = '';
            this.endTime = '';    
            this.startDate = new Date('2015/1/1');        
            this.endDate = new Date();       
            this.isMask = true;
            this.isDate = true;
        },        
        cancle(){   
            this.isReset = true;
            this.selectedValue = '';          
            this.startTime = '';
            this.endTime = ''; 
        },   
        sure(){
            if(this.startTime){
                if(this.endTime == ''){
                    this.$toast.bottom(this.$t('wdkj.qxzjssj'));
                    return;
                }
            }  
            if(this.endTime){
                if(this.startTime == ''){
                    this.$toast.bottom(this.$t('wdkj.qxzkssj'));
                    return;
                }
            }               
            let startTimes = parseInt(new Date(this.startTime).getTime()/1000);
            let endTimes = parseInt(new Date(this.endTime).getTime()/1000);
            if(startTimes > endTimes){
                this.$toast.bottom(this.$t('wdkj.sjsxts'));
                return;
            }else if(startTimes == endTimes){
                this.$toast.bottom(this.$t('wdkj.sjsxts2'));
                return;
            } 
            this.startTimes = startTimes;
            this.endTimes = endTimes; 
            this.page = 1;
            this.listData = [];
            this.isDate = false;
            this.isMask = false;
            this.init(startTimes,endTimes);
            this.startTime = '';
            this.endTime = '';
        },
        jump(id){
            this.$router.push({name:'myOrderDetail',params:{id:id}});
        },
        close(){
            this.isShow = false;
            this.isMask = false;
            this.isDate = false;
        },
        goBack(){
			this.$router.go(-1);
		}      
    },
    components:{        
        noData,
        VueBetterScroll          
    },
    filters: { 
        statusText: (val) => {            
            if(val == 0){
                return that.wkz
            }else if(val == 1){
                return that.ywc
            }else{
                return that.wkz
            }           
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();            
            return Y + M + D + " " + h + m + s;
        }    
    },
    watch: {
        startTime: function(val){               
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.startTime = ''
                }else{
                    if(this.isReset){
                        this.startTime = ''
                    }else{
                        this.startTime = this.formatDate(val)
                    }                    
                }            
            }else{
                 this.startTime = ''
            }                 
        },
        endTime: function(val){
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.endTime = ''
                }else{
                    if(this.isReset){
                        this.endTime = ''
                    }else{
                        this.endTime = this.formatDate(val)
                    }                    
                }            
            }else{
                 this.endTime = ''
            }    
        }
    },
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #fff;
        font-size: .26rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;  
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        overflow: hidden;       
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: .8rem;
        font-size: .36rem;
        line-height: .8rem;
        text-align: center;
    }    
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .18rem;
        width: .24rem;
        height: .44rem;     
    } 
    .head .icon2{
        position: absolute;
        top: 50%;
        right: .1rem;
        width: .34rem;
        transform: translate(-50%,-50%);             
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: .8rem;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;    
        overflow: hidden;       
    }  
    .ul-box{
        padding: .24rem .24rem;
    }    
    .ul-box .list{  
        position: relative;         
        margin-bottom: .34rem;
        padding: .34rem .2rem .3rem .2rem;  
        background: rgb(4, 9, 37,.5); 
        border-radius: .1rem;
    }
    .ul-box .list-head{
        display: flex;  
        align-items: center;  
    }
    .ul-box .list .img{
        width: 1.25rem;
        height: .96rem;
    }
    .ul-box .list .info-box{
        flex: 1;
        margin-left: .18rem;
        color: #cecece;
        font-size: .24rem;
    }
    .ul-box .list .arrow{
        width: .16rem;
        height: .3rem;
    }
    .ul-box .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
    }
    .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .18rem;
    }
    
    .ul-box .list .info-box .text2{
        width: 40%;
    }
    .list-foot{
        padding: .3rem .26rem 0;
        color: #cecece;
        font-size: .24rem;
    }
    .list-foot .item{
        margin-bottom: .12rem;
    }
    .list-foot .item:last-child{
        margin-bottom: 0;
    }
    .list-foot .item .red{
        color: #E12626;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        padding: .12rem .22rem;
        color: #fff;
        font-size: .24rem;        
        background: #2CAADE;
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{        
        background: #9D9D9D;
    }
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: rgba(26, 36, 64,.9);
        border-radius: .2rem;  
        transform: translateY(-50%);      
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap2 .tips{
        padding: 0 .44rem;
        color: #D1D1D1;
        font-size: .24rem;
    }
    .alert-wrap2 .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem .44rem .64rem;
    }
    .alert-wrap2 .input-box .input{
        width: 2rem;
        height: .7rem;  
        color: #fff;  
        font-size: .28rem;   
        background: #405692;
        border-radius: .06rem;
        text-align: center;
    }
    .alert-wrap2 .input-box .line{
        width: .28rem; 
        height: 1px;
        background: #fff;
    }
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: .9rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .2rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .2rem 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/myOrder.vue